import { render } from "./PasoriVevoContainer.vue?vue&type=template&id=e54a1cc4&scoped=true&ts=true"
import script from "./PasoriVevoContainer.vue?vue&type=script&lang=ts"
export * from "./PasoriVevoContainer.vue?vue&type=script&lang=ts"

import "./PasoriVevoContainer.vue?vue&type=style&index=0&id=e54a1cc4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e54a1cc4"]])

export default __exports__